import instance from '../../api';
import { ErrorNotification } from '../../../Utils/data';

export interface HistoryModelItem {
  title: string;
  key: string;
}

export const historiesApi = {
  async read(
    driverId: string | number,
    editedById: string | number,
    companyId: string | number,
    skip: number,
    model: string,
    status: string,
    type?: string,
  ) {
    if (driverId === undefined) driverId = '';
    if (editedById === undefined) editedById = '';
    if (companyId === undefined) companyId = '';

    try {
      let url = `activeDeactives/searching-list?page=${skip}&perPage=10&driverId=${driverId}&editedById=${editedById}&companyId=${companyId}&model=${model}&status=${status}`;
      if (type) {
        url += `&type=${encodeURIComponent(type)}`;
      }

      const { data }: any = await instance(url);
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async getHistoryModels(): Promise<HistoryModelItem[] | undefined> {
    try {
      const { data }: any = await instance('admins/history-models');
      return Array.isArray(data) ? data : data?.data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data?.error?.message || error.message,
        });
      }
    }
  },
};
